import {Button, DatePicker, Form, Input, message, Radio} from "antd";
import React from "react";
import {ServiceTypeFilter} from "../../../../../filters/ServiceType";
import {SiteFilter} from "../../../../../filters/Site";
import {CrmBillToFilter} from "../../../../../filters/CrmBillTo";
import {ProposalPost, ProposalUpdate} from "../../../../../models/crm/proposal";


const FormItem = Form.Item;
const moment = require('moment');


class ProposalFieldsForm extends React.Component {
    state = {
        created: 0,
        loading: false,
    };

    submitProposalForm = () => {
        const {created} = this.state;
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({loading: true});
                values['date'] = values['date'].format('YYYY-MM-DD');
                if(values['anticipated_start_date'])
                    values['anticipated_start_date'] = values['anticipated_start_date'].format('YYYY-MM-DD');
                created ?
                    ProposalUpdate(created, values)
                        .then(response => {
                            message.success("Updated Details");
                            this.setState({loading: false, created: response.id});
                            this.props.setProposal(response);
                            this.props.onNext()
                        })
                    :
                    ProposalPost(values)
                        .then(response => {
                            this.setState({loading: false, created: response.id});
                            this.props.setProposal(response);
                            this.props.onNext()
                        })
            }
        })
    };

    hasErrors() {
        const {getFieldsValue} = this.props.form;
        const values = getFieldsValue(['site', 'bill_to_id', 'breakdown_cost', 'date', 'service_type']);
        const fields = Object.keys(values);
        return fields.some(field => !values[field]);
    }

    componentDidMount() {
        if (this.props.onRef)
            this.props.onRef(this)
    }

    handleCRMBillToContact = (contact, bill_to_id) => {
        this.props.form.setFieldsValue({contact, bill_to_id})
    };

    render() {
        const {loading} = this.state;
        const {getFieldDecorator, getFieldValue} = this.props.form;
        return (
            <React.Fragment>
                <div className="row m-0 other-wrk-fields">
                    <div className="col-sm-12 col-12">
                        <div className="row">
                            <div className="col-sm-4 col-12 pos-relative">
                                <div className="floating-label">
                                    <FormItem label="Site">
                                        {getFieldDecorator('site', {
                                            rules: [{required: true, message: 'Please select site'}],
                                        })(<SiteFilter disableBill={true} onRef={ref => (this.site = ref)}/>)}
                                    </FormItem>
                                </div>
                            </div>
                            <div className="col-sm-4 col-12">
                                <div className="floating-label">
                                    <FormItem label="Bill To Contact">
                                        {getFieldDecorator('contact', {
                                        })(<CrmBillToFilter onChange={this.handleCRMBillToContact} onRef={ref => (this.contact = ref)}/>)}
                                    </FormItem>
                                </div>
                            </div>
                            {getFieldDecorator('bill_to_id', {
                            })(<input type="hidden"/>)}
                            <div className="col-sm-4 col-12">
                                <div className="floating-label">
                                    <FormItem label="Cost Setting">
                                        {getFieldDecorator('breakdown_cost', {
                                            rules: [{required: true, message: 'Please select cost setting'}],
                                        })(<Radio.Group>
                                            <Radio value={1} style={{width: '100%'}}>
                                                Show Breakdown of Cost
                                            </Radio>
                                            <Radio value={2} style={{width: '100%'}}>
                                                Hide Breakdown of Cost
                                            </Radio>
                                            <Radio value={3} style={{width: '100%'}}>
                                                Custom Breakdown of Cost
                                            </Radio>
                                            <Radio value={4} style={{width: '100%'}}>
                                                Custom Lump Sum
                                            </Radio>
                                            <Radio value={5} style={{width: '100%'}}>
                                                Custom Rate by Percentage
                                            </Radio>
                                        </Radio.Group>)}
                                    </FormItem>
                                    {[4, 5].includes(getFieldValue('breakdown_cost')) && getFieldDecorator('flat_rate', {})(<Input
                                        prefix="$" style={{width: "85%", marginLeft: 10}}/>)}
                                </div>
                            </div>

                        </div>
                        <div className="row">
                            <div className="col-sm-4 col-12">
                                <div className="floating-label">
                                    <FormItem label="Creation Date">
                                        {getFieldDecorator('date', {
                                            rules: [{required: true, message: 'Please select date'}],
                                            initialValue: moment()
                                        })(<DatePicker/>)}
                                    </FormItem>
                                </div>
                            </div>
                            <div className="col-sm-4 col-12">
                                <div className="floating-label">
                                    <FormItem label="Anticipated Start Date">
                                        {getFieldDecorator('anticipated_start_date', {})(<DatePicker
                                            placeholder="Enter Anticipated Start Date"
                                            className="drawer-datepicker w-100"/>)}
                                    </FormItem>
                                </div>
                            </div>
                            <div className="col-sm-4 col-12">
                                <div className="floating-label">
                                    <FormItem label="Service Type">
                                        {getFieldDecorator('service_type', {
                                            rules: [{required: true, message: 'Please select service type name'}],
                                        })(<ServiceTypeFilter onRef={ref => (this.service_type = ref)}/>)}
                                    </FormItem>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row step-footer ">
                    <div className="col-12 steps-action text-right">
                        <Button className="nxtPrev-btn" loading={loading} disabled={this.hasErrors()}
                                type="primary"
                                onClick={this.submitProposalForm}>Next</Button>
                    </div>
                </div>

            </React.Fragment>
        )
    }
}

export const ProposalFields = Form.create()(ProposalFieldsForm);



// WEBPACK FOOTER //
// ./src/pages/crm/proposals/popups/add_proposal_steps/ProposalFields.jsx